import {useQuery} from "@tanstack/react-query";
import {getHeadbandService} from "../../services/games/gamesList/headband.service";

const ONE_HOUR = 1000 * 60 * 60;

export const useGetBigWinners = () => {
  const {data, isPending} = useQuery({
    queryKey: ["bigWinners"],
    queryFn: () => getHeadbandService(),
    staleTime: ONE_HOUR,
    gcTime: ONE_HOUR,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
  const winners = data?.data?.data?.winners || [];
  return {
    data,
    isPending,
    winners,
  };
};
